import { ApolloClient, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { ArgoContext } from '@awsscm/argo-core/argo';

interface ContextualFetch {
  (input: Request | string, init?: RequestInit): Promise<Response>;
  context?: ArgoContext;
}

const fetch: ContextualFetch = (input, init?) => {
  if (fetch.context) {
    return fetch.context.fetchWithAwsAuth(input, init);
  }
  return Promise.reject(new Error('ArgoAppContext not set'));
};

const client = new ApolloClient({
  cache: new InMemoryCache({}),
  defaultOptions: {
    query: {
      errorPolicy: 'none',
    },
    mutate: {
      errorPolicy: 'none',
    },
  },
  link: new HttpLink({
    uri: '/graphV2',
    fetch,
  }),

  queryDeduplication: true,
});

/** Gets an ApolloClient in exchange for an ArgoContext. */
export default function getApolloClient(context: ArgoContext): ApolloClient<NormalizedCacheObject> {
  fetch.context = context;
  return client;
}
